import React from 'react';
import { formatPrice } from '../../../../utils/promo-presentation-utils';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import './BmsmTiers.scss';

export const BmsmTiers = () => {
  const { rewardTiers } = usePromoModel();

  return (
    <div className="promo-bmsm-tiers">
      {rewardTiers.map(({ minPurchaseAmount, minPurchaseQuantity, rewardPercent, rewardAmountPerOrder }, i) => {
        const message = minPurchaseQuantity
          ? `Buy ${minPurchaseQuantity}`
          : `Spend ${formatPrice(minPurchaseAmount, true)}`;
        const reward = rewardPercent
          ? `${rewardPercent}% Off`
          : `${formatPrice(rewardAmountPerOrder, true)} Off`;

        return (
          <div className="promo-bmsm-tier" key={`promo-bmsm-tier-${i}`}>
            <span>{message}</span>
            <span className="promo-bmsm-tier__reward">{reward}</span>
          </div>
        );
      })}
    </div>
  );
};

BmsmTiers.displayName = 'BmsmTiers';
